// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__whkwq","alert":"SettungsInbox_alert__-cfEB"};